import React, { useState, useEffect } from "react";
import { getArticles, deleteArticle } from "../../RestServices/videosService";
import moment from "moment";
import { Row, Col, Card, Typography, Input, Button, message } from "antd";
import { NewsEnum } from "../../shared";
import CategoryDropDown from "../../utils/dropDown/CategoryDropDown";

const DraftsList = (props) => {
  const [drafts, setDrafts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [categoryFilter, setCategoryFilter] = useState("");

  const token = props.Auth?.user?.token;
  const { Title } = Typography;

  const fetchDrafts = async () => {
    if (!token) return;
    setIsLoading(true);
    try {
      const data = await getArticles(
        {
          pageNo: 1,
          limit: 100,
          status: "Draft",
          searchQuery,
          category: categoryFilter,
        },
        token
      );
      if (data && data.articles && data.articles.docs) {
        setDrafts(data.articles.docs);
      }
    } catch (err) {
      console.error("Failed to fetch drafts:", err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchDrafts();
  }, [token, searchQuery, categoryFilter]);

  const handleDelete = async (e, draftId) => {
    e.stopPropagation();
    if (!token) return;
    if (window.confirm("Are you sure you want to permanently delete this draft? This action cannot be undone.")) {
      try {
        await deleteArticle({ articleId: draftId }, token);
        message.success("Draft article deleted successfully!");
        fetchDrafts();
      } catch (err) {
        console.error("Failed to delete draft:", err);
        message.error("Failed to delete draft. Please try again.");
      }
    }
  };

  const handleResume = async (draft) => {
    if (!props.setSelected) return;
    if (!draft?._id) return;
    try {
      message.loading({ content: "Loading full draft content...", key: "loading_draft" });
      const data = await getArticles(
        { articleId: draft._id },
        token
      );
      const fullArticle = data?.articles?.docs?.[0];
      if (!fullArticle) {
        message.error({ content: "Could not load the full draft content.", key: "loading_draft" });
        return;
      }
      message.success({ content: "Draft loaded successfully!", key: "loading_draft", duration: 1 });
      props.setSelected("AI_Article", "", fullArticle);
    } catch (err) {
      console.error("Failed to load full draft:", err);
      message.error({ content: "Failed to load full draft. Please try again.", key: "loading_draft" });
    }
  };

  const handleStatusFilterChange = (status) => {
    if (props.setSelected) {
      if (status === "All") {
        props.setSelected("News_Articles", "", { statusFilter: "" });
      } else if (status === "Published") {
        props.setSelected("News_Articles", "", { statusFilter: "Published" });
      }
    }
  };

  return (
    <div style={{ padding: "24px", minHeight: "100vh", backgroundColor: "#f8fafc" }}>
      {/* Top filter part, identical to NewsAndArticles */}
      <Row style={{ marginBottom: "20px" }}>
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <div>
            <Card>
              <div className="flex-between">
                <div style={{ width: "100%" }}>
                  <Row gutter={[12, 12]}>
                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                      <div className="flex-col" style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "6px" }}>
                        <Title level={2} className="mb-0 text-primary" style={{ height: "40px", lineHeight: "40px", whiteSpace: "nowrap" }}>
                          Saved Article Drafts
                        </Title>
                        <Button 
                          type="primary"
                          onClick={() => props.setSelected && props.setSelected("AI_Article")}
                          style={{
                            borderRadius: "10px",
                            backgroundColor: "#fb6222",
                            borderColor: "#fb6222",
                            fontWeight: "800",
                            fontSize: "12.5px",
                            height: "32px",
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "6px",
                            boxShadow: "0 4px 10px rgba(251, 98, 34, 0.15)",
                            marginTop: "4px"
                          }}
                        >
                          <svg style={{ width: "14px", height: "14px" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M12 4v16m8-8H4" />
                          </svg>
                          Write New Article
                        </Button>
                      </div>
                    </Col>
                    <Col xs={24} sm={24} md={5} lg={5} xl={5}>
                      <div className="flex-col">
                        <Title level={4} className="mb-0 text-primary">Status Filter</Title>
                        <div style={{
                          display: "flex",
                          background: "#f1f5f9",
                          padding: "4px",
                          borderRadius: "10px",
                          border: "1px solid #e2e8f0",
                          width: "100%",
                          height: "38px",
                          boxSizing: "border-box"
                        }}>
                          <button
                            type="button"
                            onClick={() => handleStatusFilterChange("All")}
                            style={{
                              flex: 1,
                              border: "none",
                              background: "transparent",
                              color: "#64748b",
                              borderRadius: "8px",
                              fontSize: "12.5px",
                              fontWeight: "800",
                              cursor: "pointer",
                              boxShadow: "none",
                              transition: "all 0.2s ease"
                            }}
                          >
                            All
                          </button>

                          <button
                            type="button"
                            style={{
                              flex: 1,
                              border: "none",
                              background: "#ffffff",
                              color: "#fb6222",
                              borderRadius: "8px",
                              fontSize: "12.5px",
                              fontWeight: "800",
                              cursor: "pointer",
                              boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
                              transition: "all 0.2s ease"
                            }}
                          >
                            Drafts
                          </button>
                        </div>
                      </div>
                    </Col>
                    <Col xs={24} sm={24} md={5} lg={5} xl={5}>
                      <div className="flex-col">
                        <Title level={4} className="mb-0 text-primary">Search Text</Title>
                        <Input
                          placeholder="Search..."
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                          style={{ width: "100%" }}
                        />
                      </div>
                    </Col>
                    <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                      <div className="flex-col">
                        <Title level={4} className="mb-0 text-primary">Select Category</Title>
                        <CategoryDropDown
                          category={categoryFilter}
                          categoriesOptions={NewsEnum}
                          setCategory={setCategoryFilter}
                        />
                      </div>
                    </Col>
                  </Row>
                </div>

              </div>
            </Card>
          </div>
        </Col>
      </Row>

      {/* Drafts Listing Card Container */}
      <div style={{
        backgroundColor: "#ffffff",
        borderRadius: "16px",
        boxShadow: "0 1px 3px rgba(0,0,0,0.02)",
        border: "1px solid #e2e8f0",
        overflow: "hidden"
      }}>
        {isLoading ? (
          <div style={{ padding: "60px", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <div style={{
              width: "36px",
              height: "36px",
              border: "3.5px solid #f1f5f9",
              borderTopColor: "#fb6222",
              borderRadius: "50%",
              animation: "spin 0.8s linear infinite"
            }} />
            <style>{`
              @keyframes spin {
                to { transform: rotate(360deg); }
              }
            `}</style>
          </div>
        ) : drafts.length === 0 ? (
          <div style={{
            padding: "80px 40px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center"
          }}>
            <div style={{
              width: "60px",
              height: "60px",
              borderRadius: "50%",
              backgroundColor: "#fff7ed",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: "16px",
              border: "1.5px solid #ffedd5"
            }}>
              <svg style={{ width: "28px", height: "28px", color: "#fb6222" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
            </div>
            <h3 style={{ margin: "0 0 8px 0", fontSize: "16px", fontWeight: "750", color: "#0f172a" }}>
              No Saved Drafts Found!
            </h3>
            <p style={{ margin: "0 0 24px 0", fontSize: "14px", color: "#64748b", maxWidth: "340px" }}>
              {searchQuery || categoryFilter ? "No drafts match your current search/filter. Try changing your query!" : "You don't have any article drafts yet. Create a new article inside the AI panel to see it here!"}
            </p>
          </div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column" }}>
            {drafts.map((draft, idx) => {
              const filledFields = [
                draft.title,
                draft.description,
                draft.quickAnswer,
                draft.articleImage?.[0]?.url,
                draft.focusKeyword,
                draft.metaDescription,
                draft.subCategory,
                draft.province,
                draft.city
              ].filter(Boolean).length;
              const progressVal = Math.round((filledFields / 9) * 100);

              return (
                <div
                  key={draft._id}
                  onClick={() => handleResume(draft)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "20px 24px",
                    borderBottom: idx === drafts.length - 1 ? "none" : "1px solid #f1f5f9",
                    cursor: "pointer",
                    transition: "all 0.15s ease",
                    backgroundColor: "#ffffff"
                  }}
                  onMouseOver={(e) => e.currentTarget.style.backgroundColor = "#faf5f2"}
                  onMouseOut={(e) => e.currentTarget.style.backgroundColor = "#ffffff"}
                >
                  {/* Left Metadata */}
                  <div style={{ flex: 1, minWidth: 0, paddingRight: "16px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "6px" }}>
                      <span style={{
                        fontSize: "11px",
                        fontWeight: "800",
                        padding: "3px 8px",
                        backgroundColor: "#f0fdf4",
                        color: "#15803d",
                        borderRadius: "9999px",
                        textTransform: "uppercase",
                        letterSpacing: "0.05em"
                      }}>
                        {draft.pageCategory?.[0] || draft.pageCategory || "General"}
                      </span>
                      <span style={{ fontSize: "12px", color: "#94a3b8" }}>
                        Updated {moment(draft.updatedAt || draft.createdAt).fromNow()}
                      </span>
                    </div>

                    <h2 style={{
                      margin: 0,
                      fontSize: "15px",
                      fontWeight: "750",
                      color: "#0f172a",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis"
                    }}>
                      {draft.title || "Untitled Draft Article"}
                    </h2>
                  </div>

                  {/* Middle Progress tracking */}
                  <div style={{ width: "160px", display: "flex", flexDirection: "column", gap: "4px", paddingRight: "16px" }}>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", fontSize: "11.5px", fontWeight: "700" }}>
                      <span style={{ color: "#64748b" }}>Progress</span>
                      <span style={{ color: progressVal === 100 ? "#10b981" : "#fb6222" }}>{progressVal}%</span>
                    </div>
                    <div style={{ width: "100%", height: "6px", backgroundColor: "#f1f5f9", borderRadius: "9999px", overflow: "hidden" }}>
                      <div style={{
                        width: `${progressVal}%`,
                        height: "100%",
                        background: "linear-gradient(90deg, #fb6222 0%, #de923b 100%)",
                        borderRadius: "9999px",
                        transition: "width 0.3s ease"
                      }} />
                    </div>
                  </div>

                  {/* Action Buttons */}
                  <div style={{ display: "flex", alignItems: "center", gap: "10px" }} onClick={(e) => e.stopPropagation()}>
                    <button
                      type="button"
                      onClick={() => handleResume(draft)}
                      style={{
                        padding: "8px 16px",
                        borderRadius: "10px",
                        background: "linear-gradient(135deg, #1e293b 0%, #0f172a 100%)",
                        color: "#ffffff",
                        border: "none",
                        fontSize: "12px",
                        fontWeight: "800",
                        cursor: "pointer",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "6px",
                        boxShadow: "0 4px 6px -1px rgba(15, 23, 42, 0.15)",
                        transition: "all 0.15s ease"
                      }}
                      onMouseOver={(e) => e.currentTarget.style.filter = "brightness(0.9)"}
                      onMouseOut={(e) => e.currentTarget.style.filter = "none"}
                    >
                      Resume Writing
                    </button>

                    <button
                      type="button"
                      onClick={(e) => handleDelete(e, draft._id)}
                      style={{
                        width: "36px",
                        height: "36px",
                        borderRadius: "10px",
                        backgroundColor: "#fef2f2",
                        border: "1.5px solid #fee2e2",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        color: "#ef4444",
                        transition: "all 0.15s ease"
                      }}
                      onMouseOver={(e) => {
                        e.currentTarget.style.backgroundColor = "#fee2e2";
                        e.currentTarget.style.color = "#b91c1c";
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.backgroundColor = "#fef2f2";
                        e.currentTarget.style.color = "#ef4444";
                      }}
                      title="Delete Draft"
                    >
                      <svg style={{ width: "16px", height: "16px" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                      </svg>
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default DraftsList;
